import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { i18n } from 'i18n';
import { AccessType } from './autoAssignUtils';

interface WizardStepAccessTypeProps {
  accessType: AccessType;
  onSelect: (accessType: AccessType) => void;
  onBack: () => void;
  onConfirm: () => void;
}

const TopAccessDiagram = () => (
  <svg width="100" height="80" viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg">
    <rect x="25" y="30" width="50" height="40" fill="#4488ff" fillOpacity="0.3" stroke="#4488ff" strokeWidth="2" />
    <line x1="50" y1="5" x2="50" y2="28" stroke="#ffaa00" strokeWidth="2" />
    <polygon points="45,22 50,30 55,22" fill="#ffaa00" />
  </svg>
);

const BottomAccessDiagram = () => (
  <svg width="100" height="80" viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg">
    <rect x="25" y="10" width="50" height="40" fill="#4488ff" fillOpacity="0.3" stroke="#4488ff" strokeWidth="2" />
    <line x1="50" y1="75" x2="50" y2="52" stroke="#ffaa00" strokeWidth="2" />
    <polygon points="45,58 50,50 55,58" fill="#ffaa00" />
  </svg>
);

const WizardStepAccessType = ({ accessType, onSelect, onBack, onConfirm }: WizardStepAccessTypeProps) => (
  <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Typography variant="h6">{i18n._('Select Access Type')}</Typography>
    <Typography variant="body2" color="text.secondary">
      {i18n._('How do stopes connect to the reticulation network?')}
    </Typography>

    <Card variant="outlined" sx={{ borderColor: accessType === 'top' ? 'secondary.main' : 'divider' }}>
      <CardActionArea onClick={() => onSelect('top')}>
        <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <TopAccessDiagram />
          <Box>
            <Typography variant="subtitle1">{i18n._('Top Access')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {i18n._('Pipes enter the stope from above.')}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>

    <Card variant="outlined" sx={{ borderColor: accessType === 'bottom' ? 'secondary.main' : 'divider' }}>
      <CardActionArea onClick={() => onSelect('bottom')}>
        <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <BottomAccessDiagram />
          <Box>
            <Typography variant="subtitle1">{i18n._('Bottom Access')}</Typography>
            <Typography variant="body2" color="text.secondary">
              {i18n._('No top access to the stope.')}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>

    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
      <Button variant="outlined" color="secondary" onClick={onBack} fullWidth>
        {i18n._('Back')}
      </Button>
      <Button variant="contained" color="secondary" onClick={onConfirm} fullWidth>
        {i18n._('Next')}
      </Button>
    </Box>
  </Box>
);

export default WizardStepAccessType;
